<template>
  <div id="indexFrame">
    <el-container class="h-p-100">
      <el-header>
        <div class="left">
          <span style="font-size: 24px;">智能门锁后台管理系统</span>
          <span style="font-size: 14px;margin-left: 25px;font-weight: bold;">{{agencyName}}</span>
          <!--<img style="height:40px; position:relative; top:-2px" src="../../assets/imgs/logo-white.png">-->
        </div>
        <div class="right">
          <i class="iconfont icon-yonghu user-icon"></i>
          <el-dropdown trigger="click" placement="bottom" :show-timeout="100" @command="handleCommand" @visible-change="onDropdownToggle">
            <span style="color:#fff; cursor:pointer; outline:none">
              {{username}}
              <i class="el-icon-arrow-down" :style="arrowStyle"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="changePass" style="border-top: 1px solid rgba(255,255,255,0.2);height: 39px;
    line-height: 39px;">
                <span>修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="changeNickname">
                <span>修改昵称</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <i class="iconfont icon-icon_logout user-logout" @click="logout"><span class="log-text">注销</span></i>
        </div>
      </el-header>
      <router-view class=""></router-view>
    </el-container>
    <el-dialog class="index-changepass-dialog"
                title="修改密码"
                 :visible.sync="dialogVisible"
                 :close-on-click-modal="false"
                 width="40%">
        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
          <el-form-item label="当前密码" prop="oldPasswd">
            <el-input type="password" v-model="ruleForm2.oldPasswd"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPasswd">
            <el-input type="password" v-model="ruleForm2.newPasswd" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel_change('ruleForm2')">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm2')">提 交</el-button>
        </span>
      </el-dialog>
    <el-dialog class="index-changepass-dialog"
               title="修改昵称"
               :visible.sync="dialogVisibleNickname"
               :close-on-click-modal="false"
               width="40%">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="新昵称" prop="oldPasswd">
          <el-input type="text" v-model="nickname"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="cancel_change_nickname()">取 消</el-button>
          <el-button type="primary" @click="submitChangeNickname('ruleForm2')">提 交</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<style lang="scss">
  @import "../../assets/scss/variable";

  .el-dropdown-menu__item .iconfont {
    font-size: 14px;
    font-weight: bold;
    margin-right: 2px;
  }
  .el-dropdown-menu {
    background-color: #347EBC!important;
    border: 1px solid #347EBC !important;
    border-radius: unset;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    -webkit-box-shadow: 0 6px 6px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 6px 6px 0 rgba(0, 0, 0, .1);
    &.el-popper[x-placement^=bottom] {
      margin-top: -1px;
    }
    .popper__arrow{
      display: none !important;
    }
    .el-dropdown-menu__item {
      color: #fff !important;
      border-bottom: 1px solid rgba(255,255,255,0.2) !important;
      &:hover{
        background-color: rgb(33, 118, 189) !important;
        color: #fff !important;
      }
    }
  }

  #indexFrame {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .index-header {
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: right;
    }
    .el-header {
      background-color: #347EBC;
      border-bottom:1px solid #999;
      color: #333;
      line-height: 60px;
      padding: 0 0 0 20px;
      .left{
        float:left;
        height: 60px;
        color: #fff;
        font-family: Microsoft YaHei;
      }
      .right{
        float:right;
        height: 60px;
        padding:0 20px;
        .user-icon{
          color: #fff;
          font-size: 24px;

        }
        .el-dropdown{
          vertical-align: top;
        }
        .user-logout{
          color: #fff;
          font-size: 20px;
          margin-left: 20px;
          cursor: pointer;
          .log-text{
            font-size: 14px;
            position: relative;
            top: -2px;
            padding-left: 5px;
          }
        }
      }

    }
    .el-aside {
      color: #333;
      height: 100%;
    }
    .el-menu {
    }
    .index-changepass-dialog {
      .el-dialog__body{
        padding: 30px 70px 20px 10px;
      }
      .change-pass-dialog {
        background-color: red;
        min-width: 500px;
      }
      .el-dialog__header {
        background-color: #409EFF;
        color: #fff
      }
      .el-dialog__header .el-dialog__title {
        color: #fff;
        position: relative;
        top:-5px
      }
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        position: relative;
        top:-5px
      }
      .change-password {
        color: #000;
        font-size: 16px;
        margin-bottom: 20px;
      }
      .change-input {
        margin-top: 5px;
      }
    }
  }
</style>

<script>
  import md5 from 'js-md5'
  import {changePassword,changeNickname} from '@/fetch/index'

  export default {
    data() {
      let username = window.localStorage.getItem('username')
      let agencyName = window.localStorage.getItem('agencyName')

      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.newPasswd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        role: window.localStorage.getItem('role'),
        agencyName: agencyName,
        isDropdownOpen: false,
        username: username,
        nickname: '',
        dialogVisible: false,  // 修改密码弹窗、
        dialogVisibleNickname: false,
        ruleForm2: {
          newPasswd: '',
          checkPass: '',
          oldPasswd: '',
          roleType: 'agency',
          loading: false
        },
        rules2: {
          newPasswd: [
            { validator: validatePass, trigger: 'blur' }  //  trigger表示事件触发类型，blur失去焦点时触发
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },

      }
    },
    computed: {
      arrowStyle() {
        return {
          transition: 'transform .3s',
          transform: this.isDropdownOpen ? 'rotateZ(180deg)' : 'none'
        }
      }
    },
    created() {
      let token = window.localStorage.getItem('token')
      if(!token) {
        this.$router.push({name: 'Login'})
      }
    },
    methods: {
      onDropdownToggle(val) {
        this.isDropdownOpen = val
      },
      handleCommand(command) {
        if(command === "logout") {
          this.logout()
        }
      },
      logout() {
        if(this.role == 'admin'){
          window.localStorage.clear()
          this.$router.push({name: 'adminLogin'})
        } else {
          window.localStorage.clear()
          this.$router.push({name: 'factoryLogin'})
        }

      },
      changePass() { //是否显示修改密码弹窗
        this.dialogVisible = !this.dialogVisible;
      },
      changeNickname(){
        this.dialogVisibleNickname=true
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            try {
              let res = await changePassword({  // 服务器响应的信息
                oldPasswd: md5(this.ruleForm2.oldPasswd),  // 给密码进行md5加密
                newPasswd: md5(this.ruleForm2.newPasswd)  // 给密码进行md5加密
              })
              if(res.data.result_code == 0) {  //密码修改成功
                this.$alert('密码修改成功', '提示', {
                  confirmButtonText: '确定',
                  type: 'success',
                  callback: action => {
                    this.resetForm(formName)
                    this.logout()
                  }
                });
              } else {
                this.$alert('密码修改失败', '提示', {
                  confirmButtonText: '确定',
                  type: 'error',
                });
              }
            } catch (error) {
              this.$message.error(error)
            }
          } else {
            console.log('提交失败');
            return false;
          }
        });
      },
      async submitChangeNickname(){
        if(!this.nickname){
          this.$alert('昵称不能为空', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
          });
          return
        }
        try{
          let res = await changeNickname({
            nickname: this.nickname
          })
          if(res.data.result_code == 0) {  //密码修改成功
            this.$alert('昵称修改成功', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                this.username = this.nickname
                this.cancel_change_nickname()
              }
            });
          } else {
            this.$alert('密码修改失败', '提示', {
              confirmButtonText: '确定',
              type: 'error',
            });
          }

        }catch (err){
          this.$message.error(error)
        }
      },
      cancel_change(formName){
        this.dialogVisible=false
        this.resetForm(formName)
      },
      cancel_change_nickname(){
        this.dialogVisibleNickname=false
        this.nickname = ''
      },
      resetForm(formName) {  //重置表单
        this.$refs[formName].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/IndexFrame.vue